import Notiflix from "notiflix";
import { useContext, useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { BsEnvelopeFill, BsGeoAltFill, BsTelephoneFill } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import PostApiCall from "../../helper/PostAPI";
import { newstore } from "./Store/newStore.js";
import GetSeoData from "../../../Helpers/GetSeoData.js";

function Contact() {
  const navigate = useNavigate();
  const { cartItems, storeStatus, setLoginModalStatus, setModalSide } =
    useContext(newstore);

  const [isMobile, setIsMobile] = useState(false);
  const [validated, setValidated] = useState(false);
  const [sending, setSending] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    Notiflix.Loading.Dots("...");

    setValidated(true);

    PostApiCall.postRequest(
      {
        name: formData.name,
        mobile: formData.phone,
        email: formData.email,
        message: formData.message,
      },
      "ContactUsMailer"
    )
      .then((results) => results.json())
      .then((obj) => {
        if (obj?.emailResponse) {
          Notiflix.Notify.Success("Message sent successfully!");
          setFormData({ name: "", phone: "", email: "", message: "" });
          setValidated(false);
        } else {
          Notiflix.Notify.Failure("Failed to send. Please try again.");
        }
        Notiflix.Loading.Remove();
        setSending(false);
      })
      .catch((error) => {
        console.error(error);
        Notiflix.Notify.Failure("Something went wrong. Please try again.");
        setSending(false);
        Notiflix.Loading.Remove();
      });
  };

  return (
    <>
      <GetSeoData type="Contact" />
      <Container
        className="aboutbanner"
        style={{ marginTop: isMobile ? "-60px" : "-20px" }}>
        <div className="form my-5">
          <Row className="my-5 align-items-stretch">
            {/* Left Side - Contact Info */}
            <Col md={4} xs={12} className="mb-4 ">
              <div className="p-4 bg-white rounded shadow text-start h-100 d-flex flex-column justify-content-center">
                <div className="mb-4 text-center">
                  <BsGeoAltFill className="text-success fs-2 mb-2" />
                  <p className="mb-1 fw-semibold">
                    MIG 156B, 6th Main Rd, West,
                  </p>
                  <p className="mb-1 fw-semibold">
                    Nolambur, Mogappair, Chennai,
                  </p>
                  <p className="mb-0 fw-semibold">Tamil Nadu, 600037</p>
                </div>
                <hr />
                <div className="mb-4 text-center">
                  <BsEnvelopeFill className="text-success fs-2 mb-2" />
                  <p className="mb-0 fw-semibold">wecare@arihafoods.com</p>
                </div>
                <hr />
                <div className="text-center">
                  <BsTelephoneFill className="text-success fs-2 mb-2" />
                  {/* <p className="mb-0 fw-semibold">
                    +91 9884455605 / 9841045605 / 8939744331
                  </p> */}
                  <a href={`tel:+91-98844-55605`}> +91-98844-55605

                  </a>
                  /
                  <a href="tel:9841045605">+91-98410-45605</a>/
                  <a href="tel:8939744331">+91-89397-44331</a>
                </div>
              </div>
            </Col>

            {/* Right Side - Form */}
            <Col md={8} xs={12}>
              <div className="form shadow p-4">
                <h2>Just Say Hello!</h2>
                <p className="py-3">
                  Do you fancy saying hi to me or you want to get started with
                  your project and you need my help? Feel free to contact me.
                </p>
                <Form
                  noValidate
                  validated={validated}
                  onSubmit={handleSubmit}
                  className="text-start">
                  <Row>
                    <Col md={6} xs={12}>
                      <Form.Group className="mb-3">
                        <Form.Label className="pb-3">Full Name*</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="Your Name"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6} xs={12}>
                      <Form.Group className="mb-3">
                        <Form.Label className="pb-3">Email*</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="name@example.com"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} xs={12}>
                      <Form.Group className="mb-3">
                        <Form.Label className="pb-3">Phone number*</Form.Label>
                        <Form.Control
                          type="tel"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="Your Phone no"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} xs={12}>
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlTextarea1">
                        <Form.Label>Message</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={5}
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4} xs={12}>
                      <button className="send px-5 py-3" disabled={sending}>
                        {sending ? "Sending..." : "Send Message"}
                      </button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
      <section className="fixed-bottom mb-0 ms-auto px-2">
        <div>
          <>
            <div className="d-flex flex-wrap flex-lg-nowrap justify-content-end align-items-center py-2">
              {cartItems?.length > 0 && (
                <Button
                  variant="danger"
                  size="lg"
                  className={
                    cartItems?.length > 0
                      ? "floating-button-cart floating-button-cart-btn d-flex"
                      : "floating-button-cart d-flex"
                  }
                  onClick={() => {
                    navigate("/cart");
                  }}>
                  <div>
                    <p className="mb-0 total-item-amount d-flex">
                      {cartItems?.length} Item
                      <span
                        style={{
                          display: cartItems?.length == 1 ? "none" : "block",
                        }}>
                        (s)
                      </span>
                      &nbsp; | ₹ {cartItems[0]?.fld_cart_amount_no_shipping}{" "}
                      Plus Taxes
                    </p>
                  </div>
                </Button>
              )}
            </div>
          </>
        </div>
      </section>
    </>
  );
}

export default Contact;
